import React from 'react';
import { FilterPill, FilterPillProps } from './FilterPill';
import { FilterPillsContainer, FilterPillsWrapper, ClearBtn } from './FilterPills.styles';

type Option = { value: string; label: string | React.ReactNode };

interface FilterPillsProps {
  /** A list of filter options: { value: string; label: string | React.ReactNode } */
  options?: Option[];
  /** Pill on click callback function */
  onPillClick?: (val: string) => void;
  /** FilterPill props */
  filterPillProps?: FilterPillProps;
  /** Clear up position */
  clearUpPosition?: 'left' | 'right' | null;
  onClear?: () => void;
  className?: string;
}

export const FilterPills: React.FC<FilterPillsProps> = ({
  options,
  onPillClick,
  filterPillProps,
  clearUpPosition = 'left',
  onClear,
  children,
}) => {
  return (
    <FilterPillsContainer>
      <FilterPillsWrapper>
        {clearUpPosition === 'left' ? <ClearBtn onClick={onClear}>Clear</ClearBtn> : null}
        {options?.map((option, index) => (
          <FilterPill
            key={index}
            value={option.value}
            label={typeof option.label === 'string' ? option.label : undefined}
            handlePillClick={() => onPillClick && onPillClick(option.value)}
            {...filterPillProps}
          >
            {typeof option.label !== 'string' ? option.label : undefined}
          </FilterPill>
        ))}
        {children}
        {clearUpPosition === 'right' ? <ClearBtn onClick={onClear}>Clear</ClearBtn> : null}
      </FilterPillsWrapper>
    </FilterPillsContainer>
  );
};
